class PreparationOptionsComponent extends HTMLElement {
  #abortController = new AbortController();

  connectedCallback() {
    const { signal } = this.#abortController;

    // Listen for successful cart adds on the parent product-form-component
    this.closest('product-form-component')?.addEventListener('cart:update', /** @type {EventListener} */ (/** @type {unknown} */ (this.#onCartAdd)), { signal });

    // Update selected styling when user changes radio selection
    this.addEventListener('change', this.#onSelectionChange, { signal });
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  /** @param {Event} event */
  #onSelectionChange = (event) => {
    this.querySelectorAll('.preparation-options__option').forEach((label) => {
      label.classList.remove('preparation-options__option--selected');
    });
    /** @type {HTMLElement} */ (event.target)?.closest('.preparation-options__option')?.classList.add('preparation-options__option--selected');
  };

  /** @param {CustomEvent} event */
  #onCartAdd = async (event) => {
    if (event.detail?.data?.didError) return;
    if (event.detail?.data?.source !== 'product-form-component') return;

    const selectedInput = /** @type {HTMLInputElement | null} */ (this.querySelector('input[name="preparation-option"]:checked'));
    if (!selectedInput || selectedInput.value === 'none') return;

    const prepVariantId = Number(selectedInput.value);
    const quantity = event.detail?.data?.itemCount || 1;

    // Get the bat variant ID from the parent product form hidden input
    const batVariantId = /** @type {HTMLInputElement | null} */ (this.closest('product-form-component')?.querySelector('input[name="id"]'))?.value;

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: prepVariantId,
          quantity,
          properties: {
            // Underscore prefix hides this property from the cart UI display
            _preparation_for: batVariantId,
          },
        }),
      });

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { source: 'preparation-options' } },
        })
      );
    } catch (error) {
      console.error('[preparation-options] Failed to add preparation product:', error);
    }
  };
}

if (!customElements.get('preparation-options-component')) {
  customElements.define('preparation-options-component', PreparationOptionsComponent);
}
